import * as m from "react";
import { useLayoutEffect as vn } from "react";
import { jsxs as hn, Fragment as Xn, jsx as ge } from "react/jsx-runtime";
import * as bn from "react-dom";
function nt() {
  return typeof window < "u";
}
function Ce(e) {
  return Ot(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ee(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ue(e) {
  var t;
  return (t = (Ot(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ot(e) {
  return nt() ? e instanceof Node || e instanceof ee(e).Node : !1;
}
function H(e) {
  return nt() ? e instanceof Element || e instanceof ee(e).Element : !1;
}
function U(e) {
  return nt() ? e instanceof HTMLElement || e instanceof ee(e).HTMLElement : !1;
}
function Rt(e) {
  return !nt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ee(e).ShadowRoot;
}
const Un = /* @__PURE__ */ new Set(["inline", "contents"]);
function Be(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = se(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Un.has(o);
}
const Yn = /* @__PURE__ */ new Set(["table", "td", "th"]);
function zn(e) {
  return Yn.has(Ce(e));
}
const Gn = [":popover-open", ":modal"];
function rt(e) {
  return Gn.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Zn = ["transform", "translate", "scale", "rotate", "perspective"], Jn = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Qn = ["paint", "layout", "strict", "content"];
function Lt(e) {
  const t = ot(), n = H(e) ? se(e) : e;
  return Zn.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Jn.some((r) => (n.willChange || "").includes(r)) || Qn.some((r) => (n.contain || "").includes(r));
}
function er(e) {
  let t = ve(e);
  for (; U(t) && !pe(t); ) {
    if (Lt(t))
      return t;
    if (rt(t))
      return null;
    t = ve(t);
  }
  return null;
}
function ot() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const tr = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function pe(e) {
  return tr.has(Ce(e));
}
function se(e) {
  return ee(e).getComputedStyle(e);
}
function it(e) {
  return H(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ve(e) {
  if (Ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Rt(e) && e.host || // Fallback.
    ue(e)
  );
  return Rt(t) ? t.host : t;
}
function yn(e) {
  const t = ve(e);
  return pe(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : U(t) && Be(t) ? t : yn(t);
}
function xe(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = yn(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = ee(o);
  if (i) {
    const c = xt(s);
    return t.concat(s, s.visualViewport || [], Be(o) ? o : [], c && n ? xe(c) : []);
  }
  return t.concat(o, xe(o, [], n));
}
function xt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const ke = Math.min, re = Math.max, Ye = Math.round, Ke = Math.floor, le = (e) => ({
  x: e,
  y: e
}), nr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, rr = {
  start: "end",
  end: "start"
};
function _t(e, t, n) {
  return re(e, ke(t, n));
}
function We(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ee(e) {
  return e.split("-")[0];
}
function _e(e) {
  return e.split("-")[1];
}
function wn(e) {
  return e === "x" ? "y" : "x";
}
function Rn(e) {
  return e === "y" ? "height" : "width";
}
const or = /* @__PURE__ */ new Set(["top", "bottom"]);
function me(e) {
  return or.has(Ee(e)) ? "y" : "x";
}
function xn(e) {
  return wn(me(e));
}
function ir(e, t, n) {
  n === void 0 && (n = !1);
  const r = _e(e), o = xn(e), i = Rn(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = ze(s)), [s, ze(s)];
}
function sr(e) {
  const t = ze(e);
  return [Et(e), t, Et(t)];
}
function Et(e) {
  return e.replace(/start|end/g, (t) => rr[t]);
}
const $t = ["left", "right"], Vt = ["right", "left"], cr = ["top", "bottom"], lr = ["bottom", "top"];
function ur(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Vt : $t : t ? $t : Vt;
    case "left":
    case "right":
      return t ? cr : lr;
    default:
      return [];
  }
}
function ar(e, t, n, r) {
  const o = _e(e);
  let i = ur(Ee(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(Et)))), i;
}
function ze(e) {
  return e.replace(/left|right|bottom|top/g, (t) => nr[t]);
}
function fr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function dr(e) {
  return typeof e != "number" ? fr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ge(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var mr = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ze = /* @__PURE__ */ mr.join(","), En = typeof Element > "u", De = En ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Je = !En && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Qe = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", s = i || n && t && e(t.parentNode);
  return s;
}, gr = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Cn = function(t, n, r) {
  if (Qe(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Ze));
  return n && De.call(t, Ze) && o.unshift(t), o = o.filter(r), o;
}, Tn = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var s = i.shift();
    if (!Qe(s, !1))
      if (s.tagName === "SLOT") {
        var c = s.assignedElements(), u = c.length ? c : s.children, l = e(u, !0, r);
        r.flatten ? o.push.apply(o, l) : o.push({
          scopeParent: s,
          candidates: l
        });
      } else {
        var f = De.call(s, Ze);
        f && r.filter(s) && (n || !t.includes(s)) && o.push(s);
        var g = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), h = !Qe(g, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (g && h) {
          var a = e(g === !0 ? s.children : g.children, !0, r);
          r.flatten ? o.push.apply(o, a) : o.push({
            scopeParent: s,
            candidates: a
          });
        } else
          i.unshift.apply(i, s.children);
      }
  }
  return o;
}, Sn = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, An = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || gr(t)) && !Sn(t) ? 0 : t.tabIndex;
}, pr = function(t, n) {
  var r = An(t);
  return r < 0 && n && !Sn(t) ? 0 : r;
}, vr = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Mn = function(t) {
  return t.tagName === "INPUT";
}, hr = function(t) {
  return Mn(t) && t.type === "hidden";
}, br = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, yr = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, wr = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Je(t), r = function(c) {
    return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var i = yr(o, t.form);
  return !i || i === t;
}, Rr = function(t) {
  return Mn(t) && t.type === "radio";
}, xr = function(t) {
  return Rr(t) && !wr(t);
}, Er = function(t) {
  var n, r = t && Je(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var s, c, u;
    for (i = !!((s = o) !== null && s !== void 0 && (c = s.ownerDocument) !== null && c !== void 0 && c.contains(o) || t != null && (u = t.ownerDocument) !== null && u !== void 0 && u.contains(t)); !i && o; ) {
      var l, f, g;
      r = Je(o), o = (l = r) === null || l === void 0 ? void 0 : l.host, i = !!((f = o) !== null && f !== void 0 && (g = f.ownerDocument) !== null && g !== void 0 && g.contains(o));
    }
  }
  return i;
}, Ht = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Cr = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = De.call(t, "details>summary:first-of-type"), s = i ? t.parentElement : t;
  if (De.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var c = t; t; ) {
        var u = t.parentElement, l = Je(t);
        if (u && !u.shadowRoot && o(u) === !0)
          return Ht(t);
        t.assignedSlot ? t = t.assignedSlot : !u && l !== t.ownerDocument ? t = l.host : t = u;
      }
      t = c;
    }
    if (Er(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Ht(t);
  return !1;
}, Tr = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return De.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ct = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Qe(n) || hr(n) || Cr(n, t) || // For a details element with a summary, the summary element gets the focus
  br(n) || Tr(n));
}, Tt = function(t, n) {
  return !(xr(n) || An(n) < 0 || !Ct(t, n));
}, Sr = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ar = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var s = !!o.scopeParent, c = s ? o.scopeParent : o, u = pr(c, s), l = s ? e(o.candidates) : c;
    u === 0 ? s ? n.push.apply(n, l) : n.push(c) : r.push({
      documentOrder: i,
      tabIndex: u,
      item: o,
      isScope: s,
      content: l
    });
  }), r.sort(vr).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, st = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Tn([t], n.includeContainer, {
    filter: Tt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Sr
  }) : r = Cn(t, n.includeContainer, Tt.bind(null, n)), Ar(r);
}, Mr = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Tn([t], n.includeContainer, {
    filter: Ct.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Cn(t, n.includeContainer, Ct.bind(null, n)), r;
}, On = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return De.call(t, Ze) === !1 ? !1 : Tt(n, t);
};
function It() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Ln() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function In() {
  return /apple/i.test(navigator.vendor);
}
function St() {
  const e = /android/i;
  return e.test(It()) || e.test(Ln());
}
function Or() {
  return It().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Pn() {
  return Ln().includes("jsdom/");
}
const Kt = "data-floating-ui-focusable", Lr = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function we(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function G(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Rt(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function de(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
function dt(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function Ir(e) {
  return e.matches("html,body");
}
function Z(e) {
  return e?.ownerDocument || document;
}
function Pt(e) {
  return U(e) && e.matches(Lr);
}
function qt(e) {
  return e ? e.getAttribute("role") === "combobox" && Pt(e) : !1;
}
function Pr(e) {
  if (!e || Pn()) return !0;
  try {
    return e.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function At(e) {
  return e ? e.hasAttribute(Kt) ? e : e.querySelector("[" + Kt + "]") || e : null;
}
function Le(e, t, n) {
  return n === void 0 && (n = !0), e.filter((o) => {
    var i;
    return o.parentId === t && (!n || ((i = o.context) == null ? void 0 : i.open));
  }).flatMap((o) => [o, ...Le(e, o.id, n)]);
}
function jt(e, t) {
  var n;
  let r = [], o = (n = e.find((i) => i.id === t)) == null ? void 0 : n.parentId;
  for (; o; ) {
    const i = e.find((s) => s.id === o);
    o = i?.parentId, i && (r = r.concat(i));
  }
  return r;
}
function mt(e) {
  e.preventDefault(), e.stopPropagation();
}
function kr(e) {
  return "nativeEvent" in e;
}
function Dr(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : St() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Fr(e) {
  return Pn() ? !1 : !St() && e.width === 0 && e.height === 0 || St() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Ne(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
var Nr = typeof document < "u", Br = function() {
}, J = Nr ? vn : Br;
const Wr = {
  ...m
};
function Se(e) {
  const t = m.useRef(e);
  return J(() => {
    t.current = e;
  }), t;
}
const _r = Wr.useInsertionEffect, $r = _r || ((e) => e());
function Q(e) {
  const t = m.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return $r(() => {
    t.current = e;
  }), m.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const $e = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function kn(e, t) {
  const n = st(e, $e()), r = n.length;
  if (r === 0) return;
  const o = we(Z(e)), i = n.indexOf(o), s = i === -1 ? t === 1 ? 0 : r - 1 : i + t;
  return n[s];
}
function Dn(e) {
  return kn(Z(e).body, 1) || e;
}
function Fn(e) {
  return kn(Z(e).body, -1) || e;
}
function Fe(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !G(n, r);
}
function Vr(e) {
  st(e, $e()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Xt(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
function Ut(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = me(t), s = xn(t), c = Rn(s), u = Ee(t), l = i === "y", f = r.x + r.width / 2 - o.width / 2, g = r.y + r.height / 2 - o.height / 2, h = r[c] / 2 - o[c] / 2;
  let a;
  switch (u) {
    case "top":
      a = {
        x: f,
        y: r.y - o.height
      };
      break;
    case "bottom":
      a = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      a = {
        x: r.x + r.width,
        y: g
      };
      break;
    case "left":
      a = {
        x: r.x - o.width,
        y: g
      };
      break;
    default:
      a = {
        x: r.x,
        y: r.y
      };
  }
  switch (_e(t)) {
    case "start":
      a[s] -= h * (n && l ? -1 : 1);
      break;
    case "end":
      a[s] += h * (n && l ? -1 : 1);
      break;
  }
  return a;
}
const Hr = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: g
  } = Ut(l, r, u), h = r, a = {}, p = 0;
  for (let d = 0; d < c.length; d++) {
    const {
      name: y,
      fn: R
    } = c[d], {
      x: b,
      y: w,
      data: S,
      reset: M
    } = await R({
      x: f,
      y: g,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: a,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = b ?? f, g = w ?? g, a = {
      ...a,
      [y]: {
        ...a[y],
        ...S
      }
    }, M && p <= 50 && (p++, typeof M == "object" && (M.placement && (h = M.placement), M.rects && (l = M.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : M.rects), {
      x: f,
      y: g
    } = Ut(l, h, u)), d = -1);
  }
  return {
    x: f,
    y: g,
    placement: h,
    strategy: o,
    middlewareData: a
  };
};
async function kt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: c,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: g = "floating",
    altBoundary: h = !1,
    padding: a = 0
  } = We(t, e), p = dr(a), y = c[h ? g === "floating" ? "reference" : "floating" : g], R = Ge(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(y))) == null || n ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: u
  })), b = g === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), S = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, M = Ge(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: b,
    offsetParent: w,
    strategy: u
  }) : b);
  return {
    top: (R.top - M.top + p.top) / S.y,
    bottom: (M.bottom - R.bottom + p.bottom) / S.y,
    left: (R.left - M.left + p.left) / S.x,
    right: (M.right - R.right + p.right) / S.x
  };
}
const Kr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: u,
        elements: l
      } = t, {
        mainAxis: f = !0,
        crossAxis: g = !0,
        fallbackPlacements: h,
        fallbackStrategy: a = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: d = !0,
        ...y
      } = We(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const R = Ee(o), b = me(c), w = Ee(c) === c, S = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), M = h || (w || !d ? [ze(c)] : sr(c)), F = p !== "none";
      !h && F && M.push(...ar(c, d, p, S));
      const I = [c, ...M], W = await kt(t, y), q = [];
      let _ = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (f && q.push(W[R]), g) {
        const x = ir(o, s, S);
        q.push(W[x[0]], W[x[1]]);
      }
      if (_ = [..._, {
        placement: o,
        overflows: q
      }], !q.every((x) => x <= 0)) {
        var B, X;
        const x = (((B = i.flip) == null ? void 0 : B.index) || 0) + 1, E = I[x];
        if (E && (!(g === "alignment" ? b !== me(E) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        _.every((v) => me(v.placement) === b ? v.overflows[0] > 0 : !0)))
          return {
            data: {
              index: x,
              overflows: _
            },
            reset: {
              placement: E
            }
          };
        let D = (X = _.filter((C) => C.overflows[0] <= 0).sort((C, v) => C.overflows[1] - v.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!D)
          switch (a) {
            case "bestFit": {
              var $;
              const C = ($ = _.filter((v) => {
                if (F) {
                  const T = me(v.placement);
                  return T === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  T === "y";
                }
                return !0;
              }).map((v) => [v.placement, v.overflows.filter((T) => T > 0).reduce((T, O) => T + O, 0)]).sort((v, T) => v[1] - T[1])[0]) == null ? void 0 : $[0];
              C && (D = C);
              break;
            }
            case "initialPlacement":
              D = c;
              break;
          }
        if (o !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
}, qr = /* @__PURE__ */ new Set(["left", "top"]);
async function jr(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Ee(n), c = _e(n), u = me(n) === "y", l = qr.has(s) ? -1 : 1, f = i && u ? -1 : 1, g = We(t, e);
  let {
    mainAxis: h,
    crossAxis: a,
    alignmentAxis: p
  } = typeof g == "number" ? {
    mainAxis: g,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: g.mainAxis || 0,
    crossAxis: g.crossAxis || 0,
    alignmentAxis: g.alignmentAxis
  };
  return c && typeof p == "number" && (a = c === "end" ? p * -1 : p), u ? {
    x: a * f,
    y: h * l
  } : {
    x: h * l,
    y: a * f
  };
}
const Xr = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: c
      } = t, u = await jr(t, e);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, Ur = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (y) => {
            let {
              x: R,
              y: b
            } = y;
            return {
              x: R,
              y: b
            };
          }
        },
        ...u
      } = We(e, t), l = {
        x: n,
        y: r
      }, f = await kt(t, u), g = me(Ee(o)), h = wn(g);
      let a = l[h], p = l[g];
      if (i) {
        const y = h === "y" ? "top" : "left", R = h === "y" ? "bottom" : "right", b = a + f[y], w = a - f[R];
        a = _t(b, a, w);
      }
      if (s) {
        const y = g === "y" ? "top" : "left", R = g === "y" ? "bottom" : "right", b = p + f[y], w = p - f[R];
        p = _t(b, p, w);
      }
      const d = c.fn({
        ...t,
        [h]: a,
        [g]: p
      });
      return {
        ...d,
        data: {
          x: d.x - n,
          y: d.y - r,
          enabled: {
            [h]: i,
            [g]: s
          }
        }
      };
    }
  };
}, Yr = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: c
      } = t, {
        apply: u = () => {
        },
        ...l
      } = We(e, t), f = await kt(t, l), g = Ee(o), h = _e(o), a = me(o) === "y", {
        width: p,
        height: d
      } = i.floating;
      let y, R;
      g === "top" || g === "bottom" ? (y = g, R = h === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (R = g, y = h === "end" ? "top" : "bottom");
      const b = d - f.top - f.bottom, w = p - f.left - f.right, S = ke(d - f[y], b), M = ke(p - f[R], w), F = !t.middlewareData.shift;
      let I = S, W = M;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (W = w), (r = t.middlewareData.shift) != null && r.enabled.y && (I = b), F && !h) {
        const _ = re(f.left, 0), B = re(f.right, 0), X = re(f.top, 0), $ = re(f.bottom, 0);
        a ? W = p - 2 * (_ !== 0 || B !== 0 ? _ + B : re(f.left, f.right)) : I = d - 2 * (X !== 0 || $ !== 0 ? X + $ : re(f.top, f.bottom));
      }
      await u({
        ...t,
        availableWidth: W,
        availableHeight: I
      });
      const q = await s.getDimensions(c.floating);
      return p !== q.width || d !== q.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Nn(e) {
  const t = se(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = U(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, c = Ye(n) !== i || Ye(r) !== s;
  return c && (n = i, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function Dt(e) {
  return H(e) ? e : e.contextElement;
}
function Ie(e) {
  const t = Dt(e);
  if (!U(t))
    return le(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Nn(t);
  let s = (i ? Ye(n.width) : n.width) / r, c = (i ? Ye(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const zr = /* @__PURE__ */ le(0);
function Bn(e) {
  const t = ee(e);
  return !ot() || !t.visualViewport ? zr : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Gr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== ee(e) ? !1 : t;
}
function Ae(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Dt(e);
  let s = le(1);
  t && (r ? H(r) && (s = Ie(r)) : s = Ie(e));
  const c = Gr(i, n, r) ? Bn(i) : le(0);
  let u = (o.left + c.x) / s.x, l = (o.top + c.y) / s.y, f = o.width / s.x, g = o.height / s.y;
  if (i) {
    const h = ee(i), a = r && H(r) ? ee(r) : r;
    let p = h, d = xt(p);
    for (; d && r && a !== p; ) {
      const y = Ie(d), R = d.getBoundingClientRect(), b = se(d), w = R.left + (d.clientLeft + parseFloat(b.paddingLeft)) * y.x, S = R.top + (d.clientTop + parseFloat(b.paddingTop)) * y.y;
      u *= y.x, l *= y.y, f *= y.x, g *= y.y, u += w, l += S, p = ee(d), d = xt(p);
    }
  }
  return Ge({
    width: f,
    height: g,
    x: u,
    y: l
  });
}
function ct(e, t) {
  const n = it(e).scrollLeft;
  return t ? t.left + n : Ae(ue(e)).left + n;
}
function Wn(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - ct(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Zr(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = ue(r), c = t ? rt(t.floating) : !1;
  if (r === s || c && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = le(1);
  const f = le(0), g = U(r);
  if ((g || !g && !i) && ((Ce(r) !== "body" || Be(s)) && (u = it(r)), U(r))) {
    const a = Ae(r);
    l = Ie(r), f.x = a.x + r.clientLeft, f.y = a.y + r.clientTop;
  }
  const h = s && !g && !i ? Wn(s, u) : le(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + f.x + h.x,
    y: n.y * l.y - u.scrollTop * l.y + f.y + h.y
  };
}
function Jr(e) {
  return Array.from(e.getClientRects());
}
function Qr(e) {
  const t = ue(e), n = it(e), r = e.ownerDocument.body, o = re(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = re(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + ct(e);
  const c = -n.scrollTop;
  return se(r).direction === "rtl" && (s += re(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
const Yt = 25;
function eo(e, t) {
  const n = ee(e), r = ue(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, c = 0, u = 0;
  if (o) {
    i = o.width, s = o.height;
    const f = ot();
    (!f || f && t === "fixed") && (c = o.offsetLeft, u = o.offsetTop);
  }
  const l = ct(r);
  if (l <= 0) {
    const f = r.ownerDocument, g = f.body, h = getComputedStyle(g), a = f.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, p = Math.abs(r.clientWidth - g.clientWidth - a);
    p <= Yt && (i -= p);
  } else l <= Yt && (i += l);
  return {
    width: i,
    height: s,
    x: c,
    y: u
  };
}
const to = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function no(e, t) {
  const n = Ae(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = U(e) ? Ie(e) : le(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, u = o * i.x, l = r * i.y;
  return {
    width: s,
    height: c,
    x: u,
    y: l
  };
}
function zt(e, t, n) {
  let r;
  if (t === "viewport")
    r = eo(e, n);
  else if (t === "document")
    r = Qr(ue(e));
  else if (H(t))
    r = no(t, n);
  else {
    const o = Bn(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Ge(r);
}
function _n(e, t) {
  const n = ve(e);
  return n === t || !H(n) || pe(n) ? !1 : se(n).position === "fixed" || _n(n, t);
}
function ro(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = xe(e, [], !1).filter((c) => H(c) && Ce(c) !== "body"), o = null;
  const i = se(e).position === "fixed";
  let s = i ? ve(e) : e;
  for (; H(s) && !pe(s); ) {
    const c = se(s), u = Lt(s);
    !u && c.position === "fixed" && (o = null), (i ? !u && !o : !u && c.position === "static" && !!o && to.has(o.position) || Be(s) && !u && _n(e, s)) ? r = r.filter((f) => f !== s) : o = c, s = ve(s);
  }
  return t.set(e, r), r;
}
function oo(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? rt(t) ? [] : ro(t, this._c) : [].concat(n), r], c = s[0], u = s.reduce((l, f) => {
    const g = zt(t, f, o);
    return l.top = re(g.top, l.top), l.right = ke(g.right, l.right), l.bottom = ke(g.bottom, l.bottom), l.left = re(g.left, l.left), l;
  }, zt(t, c, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function io(e) {
  const {
    width: t,
    height: n
  } = Nn(e);
  return {
    width: t,
    height: n
  };
}
function so(e, t, n) {
  const r = U(t), o = ue(t), i = n === "fixed", s = Ae(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = le(0);
  function l() {
    u.x = ct(o);
  }
  if (r || !r && !i)
    if ((Ce(t) !== "body" || Be(o)) && (c = it(t)), r) {
      const a = Ae(t, !0, i, t);
      u.x = a.x + t.clientLeft, u.y = a.y + t.clientTop;
    } else o && l();
  i && !r && o && l();
  const f = o && !r && !i ? Wn(o, c) : le(0), g = s.left + c.scrollLeft - u.x - f.x, h = s.top + c.scrollTop - u.y - f.y;
  return {
    x: g,
    y: h,
    width: s.width,
    height: s.height
  };
}
function gt(e) {
  return se(e).position === "static";
}
function Gt(e, t) {
  if (!U(e) || se(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ue(e) === n && (n = n.ownerDocument.body), n;
}
function $n(e, t) {
  const n = ee(e);
  if (rt(e))
    return n;
  if (!U(e)) {
    let o = ve(e);
    for (; o && !pe(o); ) {
      if (H(o) && !gt(o))
        return o;
      o = ve(o);
    }
    return n;
  }
  let r = Gt(e, t);
  for (; r && zn(r) && gt(r); )
    r = Gt(r, t);
  return r && pe(r) && gt(r) && !Lt(r) ? n : r || er(e) || n;
}
const co = async function(e) {
  const t = this.getOffsetParent || $n, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: so(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function lo(e) {
  return se(e).direction === "rtl";
}
const uo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zr,
  getDocumentElement: ue,
  getClippingRect: oo,
  getOffsetParent: $n,
  getElementRects: co,
  getClientRects: Jr,
  getDimensions: io,
  getScale: Ie,
  isElement: H,
  isRTL: lo
};
function Vn(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function ao(e, t) {
  let n = null, r;
  const o = ue(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), i();
    const l = e.getBoundingClientRect(), {
      left: f,
      top: g,
      width: h,
      height: a
    } = l;
    if (c || t(), !h || !a)
      return;
    const p = Ke(g), d = Ke(o.clientWidth - (f + h)), y = Ke(o.clientHeight - (g + a)), R = Ke(f), w = {
      rootMargin: -p + "px " + -d + "px " + -y + "px " + -R + "px",
      threshold: re(0, ke(1, u)) || 1
    };
    let S = !0;
    function M(F) {
      const I = F[0].intersectionRatio;
      if (I !== u) {
        if (!S)
          return s();
        I ? s(!1, I) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !Vn(l, e.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      n = new IntersectionObserver(M, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(M, w);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Xo(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = Dt(e), f = o || i ? [...l ? xe(l) : [], ...xe(t)] : [];
  f.forEach((R) => {
    o && R.addEventListener("scroll", n, {
      passive: !0
    }), i && R.addEventListener("resize", n);
  });
  const g = l && c ? ao(l, n) : null;
  let h = -1, a = null;
  s && (a = new ResizeObserver((R) => {
    let [b] = R;
    b && b.target === l && a && (a.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var w;
      (w = a) == null || w.observe(t);
    })), n();
  }), l && !u && a.observe(l), a.observe(t));
  let p, d = u ? Ae(e) : null;
  u && y();
  function y() {
    const R = Ae(e);
    d && !Vn(d, R) && n(), d = R, p = requestAnimationFrame(y);
  }
  return n(), () => {
    var R;
    f.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), g?.(), (R = a) == null || R.disconnect(), a = null, u && cancelAnimationFrame(p);
  };
}
const fo = Xr, mo = Ur, go = Kr, po = Yr, vo = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: uo,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return Hr(e, t, {
    ...o,
    platform: i
  });
};
var ho = typeof document < "u", bo = function() {
}, Ue = ho ? vn : bo;
function et(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!et(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !et(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Hn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Zt(e, t) {
  const n = Hn(e);
  return Math.round(t * n) / n;
}
function pt(e) {
  const t = m.useRef(e);
  return Ue(() => {
    t.current = e;
  }), t;
}
function yo(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: u,
    open: l
  } = e, [f, g] = m.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, a] = m.useState(r);
  et(h, r) || a(r);
  const [p, d] = m.useState(null), [y, R] = m.useState(null), b = m.useCallback((v) => {
    v !== F.current && (F.current = v, d(v));
  }, []), w = m.useCallback((v) => {
    v !== I.current && (I.current = v, R(v));
  }, []), S = i || p, M = s || y, F = m.useRef(null), I = m.useRef(null), W = m.useRef(f), q = u != null, _ = pt(u), B = pt(o), X = pt(l), $ = m.useCallback(() => {
    if (!F.current || !I.current)
      return;
    const v = {
      placement: t,
      strategy: n,
      middleware: h
    };
    B.current && (v.platform = B.current), vo(F.current, I.current, v).then((T) => {
      const O = {
        ...T,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: X.current !== !1
      };
      x.current && !et(W.current, O) && (W.current = O, bn.flushSync(() => {
        g(O);
      }));
    });
  }, [h, t, n, B, X]);
  Ue(() => {
    l === !1 && W.current.isPositioned && (W.current.isPositioned = !1, g((v) => ({
      ...v,
      isPositioned: !1
    })));
  }, [l]);
  const x = m.useRef(!1);
  Ue(() => (x.current = !0, () => {
    x.current = !1;
  }), []), Ue(() => {
    if (S && (F.current = S), M && (I.current = M), S && M) {
      if (_.current)
        return _.current(S, M, $);
      $();
    }
  }, [S, M, $, _, q]);
  const E = m.useMemo(() => ({
    reference: F,
    floating: I,
    setReference: b,
    setFloating: w
  }), [b, w]), D = m.useMemo(() => ({
    reference: S,
    floating: M
  }), [S, M]), C = m.useMemo(() => {
    const v = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return v;
    const T = Zt(D.floating, f.x), O = Zt(D.floating, f.y);
    return c ? {
      ...v,
      transform: "translate(" + T + "px, " + O + "px)",
      ...Hn(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: T,
      top: O
    };
  }, [n, c, D.floating, f.x, f.y]);
  return m.useMemo(() => ({
    ...f,
    update: $,
    refs: E,
    elements: D,
    floatingStyles: C
  }), [f, $, E, D, C]);
}
const Uo = (e, t) => ({
  ...fo(e),
  options: [e, t]
}), Yo = (e, t) => ({
  ...mo(e),
  options: [e, t]
}), zo = (e, t) => ({
  ...go(e),
  options: [e, t]
}), Go = (e, t) => ({
  ...po(e),
  options: [e, t]
});
function Zo(e) {
  const t = m.useRef(void 0), n = m.useCallback((r) => {
    const o = e.map((i) => {
      if (i != null) {
        if (typeof i == "function") {
          const s = i, c = s(r);
          return typeof c == "function" ? c : () => {
            s(null);
          };
        }
        return i.current = r, () => {
          i.current = null;
        };
      }
    });
    return () => {
      o.forEach((i) => i?.());
    };
  }, e);
  return m.useMemo(() => e.every((r) => r == null) ? null : (r) => {
    t.current && (t.current(), t.current = void 0), r != null && (t.current = n(r));
  }, e);
}
const wo = "data-floating-ui-focusable", Jt = "active", Qt = "selected", Ro = {
  ...m
};
let en = !1, xo = 0;
const tn = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + xo++
);
function Eo() {
  const [e, t] = m.useState(() => en ? tn() : void 0);
  return J(() => {
    e == null && t(tn());
  }, []), m.useEffect(() => {
    en = !0;
  }, []), e;
}
const Co = Ro.useId, Ft = Co || Eo;
let Mt;
process.env.NODE_ENV !== "production" && (Mt = /* @__PURE__ */ new Set());
function To() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Mt) != null && e.has(o))) {
    var i;
    (i = Mt) == null || i.add(o), console.error(o);
  }
}
function So() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
    },
    off(t, n) {
      var r;
      (r = e.get(t)) == null || r.delete(n);
    }
  };
}
const Ao = /* @__PURE__ */ m.createContext(null), Mo = /* @__PURE__ */ m.createContext(null), Nt = () => {
  var e;
  return ((e = m.useContext(Ao)) == null ? void 0 : e.id) || null;
}, lt = () => m.useContext(Mo);
function Me(e) {
  return "data-floating-ui-" + e;
}
function ne(e) {
  e.current !== -1 && (clearTimeout(e.current), e.current = -1);
}
const nn = /* @__PURE__ */ Me("safe-polygon");
function vt(e, t, n) {
  if (n && !Ne(n))
    return 0;
  if (typeof e == "number")
    return e;
  if (typeof e == "function") {
    const r = e();
    return typeof r == "number" ? r : r?.[t];
  }
  return e?.[t];
}
function ht(e) {
  return typeof e == "function" ? e() : e;
}
function Jo(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: i,
    elements: s
  } = e, {
    enabled: c = !0,
    delay: u = 0,
    handleClose: l = null,
    mouseOnly: f = !1,
    restMs: g = 0,
    move: h = !0
  } = t, a = lt(), p = Nt(), d = Se(l), y = Se(u), R = Se(n), b = Se(g), w = m.useRef(), S = m.useRef(-1), M = m.useRef(), F = m.useRef(-1), I = m.useRef(!0), W = m.useRef(!1), q = m.useRef(() => {
  }), _ = m.useRef(!1), B = Q(() => {
    var C;
    const v = (C = o.current.openEvent) == null ? void 0 : C.type;
    return v?.includes("mouse") && v !== "mousedown";
  });
  m.useEffect(() => {
    if (!c) return;
    function C(v) {
      let {
        open: T
      } = v;
      T || (ne(S), ne(F), I.current = !0, _.current = !1);
    }
    return i.on("openchange", C), () => {
      i.off("openchange", C);
    };
  }, [c, i]), m.useEffect(() => {
    if (!c || !d.current || !n) return;
    function C(T) {
      B() && r(!1, T, "hover");
    }
    const v = Z(s.floating).documentElement;
    return v.addEventListener("mouseleave", C), () => {
      v.removeEventListener("mouseleave", C);
    };
  }, [s.floating, n, r, c, d, B]);
  const X = m.useCallback(function(C, v, T) {
    v === void 0 && (v = !0), T === void 0 && (T = "hover");
    const O = vt(y.current, "close", w.current);
    O && !M.current ? (ne(S), S.current = window.setTimeout(() => r(!1, C, T), O)) : v && (ne(S), r(!1, C, T));
  }, [y, r]), $ = Q(() => {
    q.current(), M.current = void 0;
  }), x = Q(() => {
    if (W.current) {
      const C = Z(s.floating).body;
      C.style.pointerEvents = "", C.removeAttribute(nn), W.current = !1;
    }
  }), E = Q(() => o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1);
  m.useEffect(() => {
    if (!c) return;
    function C(P) {
      if (ne(S), I.current = !1, f && !Ne(w.current) || ht(b.current) > 0 && !vt(y.current, "open"))
        return;
      const A = vt(y.current, "open", w.current);
      A ? S.current = window.setTimeout(() => {
        R.current || r(!0, P, "hover");
      }, A) : n || r(!0, P, "hover");
    }
    function v(P) {
      if (E()) {
        x();
        return;
      }
      q.current();
      const A = Z(s.floating);
      if (ne(F), _.current = !1, d.current && o.current.floatingContext) {
        n || ne(S), M.current = d.current({
          ...o.current.floatingContext,
          tree: a,
          x: P.clientX,
          y: P.clientY,
          onClose() {
            x(), $(), E() || X(P, !0, "safe-polygon");
          }
        });
        const K = M.current;
        A.addEventListener("mousemove", K), q.current = () => {
          A.removeEventListener("mousemove", K);
        };
        return;
      }
      (w.current === "touch" ? !G(s.floating, P.relatedTarget) : !0) && X(P);
    }
    function T(P) {
      E() || o.current.floatingContext && (d.current == null || d.current({
        ...o.current.floatingContext,
        tree: a,
        x: P.clientX,
        y: P.clientY,
        onClose() {
          x(), $(), E() || X(P);
        }
      })(P));
    }
    function O() {
      ne(S);
    }
    function Y(P) {
      E() || X(P, !1);
    }
    if (H(s.domReference)) {
      const P = s.domReference, A = s.floating;
      return n && P.addEventListener("mouseleave", T), h && P.addEventListener("mousemove", C, {
        once: !0
      }), P.addEventListener("mouseenter", C), P.addEventListener("mouseleave", v), A && (A.addEventListener("mouseleave", T), A.addEventListener("mouseenter", O), A.addEventListener("mouseleave", Y)), () => {
        n && P.removeEventListener("mouseleave", T), h && P.removeEventListener("mousemove", C), P.removeEventListener("mouseenter", C), P.removeEventListener("mouseleave", v), A && (A.removeEventListener("mouseleave", T), A.removeEventListener("mouseenter", O), A.removeEventListener("mouseleave", Y));
      };
    }
  }, [s, c, e, f, h, X, $, x, r, n, R, a, y, d, o, E, b]), J(() => {
    var C;
    if (c && n && (C = d.current) != null && (C = C.__options) != null && C.blockPointerEvents && B()) {
      W.current = !0;
      const T = s.floating;
      if (H(s.domReference) && T) {
        var v;
        const O = Z(s.floating).body;
        O.setAttribute(nn, "");
        const Y = s.domReference, P = a == null || (v = a.nodesRef.current.find((A) => A.id === p)) == null || (v = v.context) == null ? void 0 : v.elements.floating;
        return P && (P.style.pointerEvents = ""), O.style.pointerEvents = "none", Y.style.pointerEvents = "auto", T.style.pointerEvents = "auto", () => {
          O.style.pointerEvents = "", Y.style.pointerEvents = "", T.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, p, s, a, d, B]), J(() => {
    n || (w.current = void 0, _.current = !1, $(), x());
  }, [n, $, x]), m.useEffect(() => () => {
    $(), ne(S), ne(F), x();
  }, [c, s.domReference, $, x]);
  const D = m.useMemo(() => {
    function C(v) {
      w.current = v.pointerType;
    }
    return {
      onPointerDown: C,
      onPointerEnter: C,
      onMouseMove(v) {
        const {
          nativeEvent: T
        } = v;
        function O() {
          !I.current && !R.current && r(!0, T, "hover");
        }
        f && !Ne(w.current) || n || ht(b.current) === 0 || _.current && v.movementX ** 2 + v.movementY ** 2 < 2 || (ne(F), w.current === "touch" ? O() : (_.current = !0, F.current = window.setTimeout(O, ht(b.current))));
      }
    };
  }, [f, r, n, R, b]);
  return m.useMemo(() => c ? {
    reference: D
  } : {}, [c, D]);
}
let rn = 0;
function Oe(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: o = !1
  } = t;
  r && cancelAnimationFrame(rn);
  const i = () => e?.focus({
    preventScroll: n
  });
  o ? i() : rn = requestAnimationFrame(i);
}
function Oo(e) {
  return e?.ownerDocument || document;
}
const Pe = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap(),
  none: /* @__PURE__ */ new WeakMap()
};
function on(e) {
  return e === "inert" ? Pe.inert : e === "aria-hidden" ? Pe["aria-hidden"] : Pe.none;
}
let qe = /* @__PURE__ */ new WeakSet(), je = {}, bt = 0;
const Lo = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, Kn = (e) => e && (e.host || Kn(e.parentNode)), Io = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = Kn(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function Po(e, t, n, r) {
  const o = "data-floating-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, s = Io(t, e), c = /* @__PURE__ */ new Set(), u = new Set(s), l = [];
  je[o] || (je[o] = /* @__PURE__ */ new WeakMap());
  const f = je[o];
  s.forEach(g), h(t), c.clear();
  function g(a) {
    !a || c.has(a) || (c.add(a), a.parentNode && g(a.parentNode));
  }
  function h(a) {
    !a || u.has(a) || [].forEach.call(a.children, (p) => {
      if (Ce(p) !== "script")
        if (c.has(p))
          h(p);
        else {
          const d = i ? p.getAttribute(i) : null, y = d !== null && d !== "false", R = on(i), b = (R.get(p) || 0) + 1, w = (f.get(p) || 0) + 1;
          R.set(p, b), f.set(p, w), l.push(p), b === 1 && y && qe.add(p), w === 1 && p.setAttribute(o, ""), !y && i && p.setAttribute(i, i === "inert" ? "" : "true");
        }
    });
  }
  return bt++, () => {
    l.forEach((a) => {
      const p = on(i), y = (p.get(a) || 0) - 1, R = (f.get(a) || 0) - 1;
      p.set(a, y), f.set(a, R), y || (!qe.has(a) && i && a.removeAttribute(i), qe.delete(a)), R || a.removeAttribute(o);
    }), bt--, bt || (Pe.inert = /* @__PURE__ */ new WeakMap(), Pe["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Pe.none = /* @__PURE__ */ new WeakMap(), qe = /* @__PURE__ */ new WeakSet(), je = {});
  };
}
function sn(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = Oo(e[0]).body;
  return Po(e.concat(Array.from(r.querySelectorAll('[aria-live],[role="status"],output'))), r, t, n);
}
const ut = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
}, tt = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const [r, o] = m.useState();
  J(() => {
    In() && o("button");
  }, []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Me("focus-guard")]: "",
    style: ut
  };
  return /* @__PURE__ */ ge("span", {
    ...t,
    ...i
  });
}), qn = /* @__PURE__ */ m.createContext(null), cn = /* @__PURE__ */ Me("portal");
function ko(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = Ft(), o = jn(), [i, s] = m.useState(null), c = m.useRef(null);
  return J(() => () => {
    i?.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [i]), J(() => {
    if (!r || c.current) return;
    const u = t ? document.getElementById(t) : null;
    if (!u) return;
    const l = document.createElement("div");
    l.id = r, l.setAttribute(cn, ""), u.appendChild(l), c.current = l, s(l);
  }, [t, r]), J(() => {
    if (n === null || !r || c.current) return;
    let u = n || o?.portalNode;
    u && !Ot(u) && (u = u.current), u = u || document.body;
    let l = null;
    t && (l = document.createElement("div"), l.id = t, u.appendChild(l));
    const f = document.createElement("div");
    f.id = r, f.setAttribute(cn, ""), u = l || u, u.appendChild(f), c.current = f, s(f);
  }, [t, n, r, o]), i;
}
function Qo(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: o = !0
  } = e, i = ko({
    id: n,
    root: r
  }), [s, c] = m.useState(null), u = m.useRef(null), l = m.useRef(null), f = m.useRef(null), g = m.useRef(null), h = s?.modal, a = s?.open, p = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!s && // Guards are only for non-modal focus management.
    !s.modal && // Don't render if unmount is transitioning.
    s.open && o && !!(r || i)
  );
  return m.useEffect(() => {
    if (!i || !o || h)
      return;
    function d(y) {
      i && Fe(y) && (y.type === "focusin" ? Xt : Vr)(i);
    }
    return i.addEventListener("focusin", d, !0), i.addEventListener("focusout", d, !0), () => {
      i.removeEventListener("focusin", d, !0), i.removeEventListener("focusout", d, !0);
    };
  }, [i, o, h]), m.useEffect(() => {
    i && (a || Xt(i));
  }, [a, i]), /* @__PURE__ */ hn(qn.Provider, {
    value: m.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: u,
      afterOutsideRef: l,
      beforeInsideRef: f,
      afterInsideRef: g,
      portalNode: i,
      setFocusManagerState: c
    }), [o, i]),
    children: [p && i && /* @__PURE__ */ ge(tt, {
      "data-type": "outside",
      ref: u,
      onFocus: (d) => {
        if (Fe(d, i)) {
          var y;
          (y = f.current) == null || y.focus();
        } else {
          const R = s ? s.domReference : null, b = Fn(R);
          b?.focus();
        }
      }
    }), p && i && /* @__PURE__ */ ge("span", {
      "aria-owns": i.id,
      style: ut
    }), i && /* @__PURE__ */ bn.createPortal(t, i), p && i && /* @__PURE__ */ ge(tt, {
      "data-type": "outside",
      ref: l,
      onFocus: (d) => {
        if (Fe(d, i)) {
          var y;
          (y = g.current) == null || y.focus();
        } else {
          const R = s ? s.domReference : null, b = Dn(R);
          b?.focus(), s?.closeOnFocusOut && s?.onOpenChange(!1, d.nativeEvent, "focus-out");
        }
      }
    })]
  });
}
const jn = () => m.useContext(qn);
function ln(e) {
  return m.useMemo(() => (t) => {
    e.forEach((n) => {
      n && (n.current = t);
    });
  }, e);
}
const Do = 20;
let Re = [];
function Bt() {
  Re = Re.filter((e) => e.isConnected);
}
function Fo(e) {
  Bt(), e && Ce(e) !== "body" && (Re.push(e), Re.length > Do && (Re = Re.slice(-20)));
}
function un() {
  return Bt(), Re[Re.length - 1];
}
function No(e) {
  const t = $e();
  return On(e, t) ? e : st(e, t)[0] || e;
}
function an(e, t) {
  var n;
  if (!t.current.includes("floating") && !((n = e.getAttribute("role")) != null && n.includes("dialog")))
    return;
  const r = $e(), i = Mr(e, r).filter((c) => {
    const u = c.getAttribute("data-tabindex") || "";
    return On(c, r) || c.hasAttribute("data-tabindex") && !u.startsWith("-");
  }), s = e.getAttribute("tabindex");
  t.current.includes("floating") || i.length === 0 ? s !== "0" && e.setAttribute("tabindex", "0") : (s !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
const Bo = /* @__PURE__ */ m.forwardRef(function(t, n) {
  return /* @__PURE__ */ ge("button", {
    ...t,
    type: "button",
    ref: n,
    tabIndex: -1,
    style: ut
  });
});
function ei(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: o = ["content"],
    guards: i = !0,
    initialFocus: s = 0,
    returnFocus: c = !0,
    restoreFocus: u = !1,
    modal: l = !0,
    visuallyHiddenDismiss: f = !1,
    closeOnFocusOut: g = !0,
    outsideElementsInert: h = !1,
    getInsideElements: a = () => []
  } = e, {
    open: p,
    onOpenChange: d,
    events: y,
    dataRef: R,
    elements: {
      domReference: b,
      floating: w
    }
  } = t, S = Q(() => {
    var L;
    return (L = R.current.floatingContext) == null ? void 0 : L.nodeId;
  }), M = Q(a), F = typeof s == "number" && s < 0, I = qt(b) && F, W = Lo(), q = W ? i : !0, _ = !q || W && h, B = Se(o), X = Se(s), $ = Se(c), x = lt(), E = jn(), D = m.useRef(null), C = m.useRef(null), v = m.useRef(!1), T = m.useRef(!1), O = m.useRef(-1), Y = m.useRef(-1), P = E != null, A = At(w), ce = Q(function(L) {
    return L === void 0 && (L = A), L ? st(L, $e()) : [];
  }), K = Q((L) => {
    const N = ce(L);
    return B.current.map((k) => b && k === "reference" ? b : A && k === "floating" ? A : N).filter(Boolean).flat();
  });
  m.useEffect(() => {
    if (r || !l) return;
    function L(k) {
      if (k.key === "Tab") {
        G(A, we(Z(A))) && ce().length === 0 && !I && mt(k);
        const j = K(), z = de(k);
        B.current[0] === "reference" && z === b && (mt(k), k.shiftKey ? Oe(j[j.length - 1]) : Oe(j[1])), B.current[1] === "floating" && z === A && k.shiftKey && (mt(k), Oe(j[0]));
      }
    }
    const N = Z(A);
    return N.addEventListener("keydown", L), () => {
      N.removeEventListener("keydown", L);
    };
  }, [r, b, A, l, B, I, ce, K]), m.useEffect(() => {
    if (r || !w) return;
    function L(N) {
      const k = de(N), z = ce().indexOf(k);
      z !== -1 && (O.current = z);
    }
    return w.addEventListener("focusin", L), () => {
      w.removeEventListener("focusin", L);
    };
  }, [r, w, ce]), m.useEffect(() => {
    if (r || !g) return;
    function L() {
      T.current = !0, setTimeout(() => {
        T.current = !1;
      });
    }
    function N(z) {
      const V = z.relatedTarget, ae = z.currentTarget, ie = de(z);
      queueMicrotask(() => {
        const te = S(), Te = !(G(b, V) || G(w, V) || G(V, w) || G(E?.portalNode, V) || V != null && V.hasAttribute(Me("focus-guard")) || x && (Le(x.nodesRef.current, te).find((be) => {
          var fe, ye;
          return G((fe = be.context) == null ? void 0 : fe.elements.floating, V) || G((ye = be.context) == null ? void 0 : ye.elements.domReference, V);
        }) || jt(x.nodesRef.current, te).find((be) => {
          var fe, ye, Wt;
          return [(fe = be.context) == null ? void 0 : fe.elements.floating, At((ye = be.context) == null ? void 0 : ye.elements.floating)].includes(V) || ((Wt = be.context) == null ? void 0 : Wt.elements.domReference) === V;
        })));
        if (ae === b && A && an(A, B), u && ae !== b && !(ie != null && ie.isConnected) && we(Z(A)) === Z(A).body) {
          U(A) && A.focus();
          const be = O.current, fe = ce(), ye = fe[be] || fe[fe.length - 1] || A;
          U(ye) && ye.focus();
        }
        if (R.current.insideReactTree) {
          R.current.insideReactTree = !1;
          return;
        }
        (I || !l) && V && Te && !T.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        V !== un() && (v.current = !0, d(!1, z, "focus-out"));
      });
    }
    const k = !!(!x && E);
    function j() {
      ne(Y), R.current.insideReactTree = !0, Y.current = window.setTimeout(() => {
        R.current.insideReactTree = !1;
      });
    }
    if (w && U(b))
      return b.addEventListener("focusout", N), b.addEventListener("pointerdown", L), w.addEventListener("focusout", N), k && w.addEventListener("focusout", j, !0), () => {
        b.removeEventListener("focusout", N), b.removeEventListener("pointerdown", L), w.removeEventListener("focusout", N), k && w.removeEventListener("focusout", j, !0);
      };
  }, [r, b, w, A, l, x, E, d, g, u, ce, I, S, B, R]);
  const oe = m.useRef(null), he = m.useRef(null), at = ln([oe, E?.beforeInsideRef]), ft = ln([he, E?.afterInsideRef]);
  m.useEffect(() => {
    var L, N;
    if (r || !w) return;
    const k = Array.from((E == null || (L = E.portalNode) == null ? void 0 : L.querySelectorAll("[" + Me("portal") + "]")) || []), z = (N = (x ? jt(x.nodesRef.current, S()) : []).find((ie) => {
      var te;
      return qt(((te = ie.context) == null ? void 0 : te.elements.domReference) || null);
    })) == null || (N = N.context) == null ? void 0 : N.elements.domReference, V = [w, z, ...k, ...M(), D.current, C.current, oe.current, he.current, E?.beforeOutsideRef.current, E?.afterOutsideRef.current, B.current.includes("reference") || I ? b : null].filter((ie) => ie != null), ae = l || I ? sn(V, !_, _) : sn(V);
    return () => {
      ae();
    };
  }, [r, b, w, l, B, E, I, q, _, x, S, M]), J(() => {
    if (r || !U(A)) return;
    const L = Z(A), N = we(L);
    queueMicrotask(() => {
      const k = K(A), j = X.current, z = (typeof j == "number" ? k[j] : j.current) || A, V = G(A, N);
      !F && !V && p && Oe(z, {
        preventScroll: z === A
      });
    });
  }, [r, p, A, F, K, X]), J(() => {
    if (r || !A) return;
    const L = Z(A), N = we(L);
    Fo(N);
    function k(V) {
      let {
        reason: ae,
        event: ie,
        nested: te
      } = V;
      if (["hover", "safe-polygon"].includes(ae) && ie.type === "mouseleave" && (v.current = !0), ae === "outside-press")
        if (te)
          v.current = !1;
        else if (Dr(ie) || Fr(ie))
          v.current = !1;
        else {
          let Te = !1;
          document.createElement("div").focus({
            get preventScroll() {
              return Te = !0, !1;
            }
          }), Te ? v.current = !1 : v.current = !0;
        }
    }
    y.on("openchange", k);
    const j = L.createElement("span");
    j.setAttribute("tabindex", "-1"), j.setAttribute("aria-hidden", "true"), Object.assign(j.style, ut), P && b && b.insertAdjacentElement("afterend", j);
    function z() {
      if (typeof $.current == "boolean") {
        const V = b || un();
        return V && V.isConnected ? V : j;
      }
      return $.current.current || j;
    }
    return () => {
      y.off("openchange", k);
      const V = we(L), ae = G(w, V) || x && Le(x.nodesRef.current, S(), !1).some((te) => {
        var Te;
        return G((Te = te.context) == null ? void 0 : Te.elements.floating, V);
      }), ie = z();
      queueMicrotask(() => {
        const te = No(ie);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        $.current && !v.current && U(te) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(te !== V && V !== L.body) || ae) && te.focus({
          preventScroll: !0
        }), j.remove();
      });
    };
  }, [r, w, A, $, R, y, x, P, b, S]), m.useEffect(() => (queueMicrotask(() => {
    v.current = !1;
  }), () => {
    queueMicrotask(Bt);
  }), [r]), J(() => {
    if (!r && E)
      return E.setFocusManagerState({
        modal: l,
        closeOnFocusOut: g,
        open: p,
        onOpenChange: d,
        domReference: b
      }), () => {
        E.setFocusManagerState(null);
      };
  }, [r, E, l, p, d, g, b]), J(() => {
    r || A && an(A, B);
  }, [r, A, B]);
  function Ve(L) {
    return r || !f || !l ? null : /* @__PURE__ */ ge(Bo, {
      ref: L === "start" ? D : C,
      onClick: (N) => d(!1, N.nativeEvent),
      children: typeof f == "string" ? f : "Dismiss"
    });
  }
  const He = !r && q && (l ? !I : !0) && (P || l);
  return /* @__PURE__ */ hn(Xn, {
    children: [He && /* @__PURE__ */ ge(tt, {
      "data-type": "inside",
      ref: at,
      onFocus: (L) => {
        if (l) {
          const k = K();
          Oe(o[0] === "reference" ? k[0] : k[k.length - 1]);
        } else if (E != null && E.preserveTabOrder && E.portalNode)
          if (v.current = !1, Fe(L, E.portalNode)) {
            const k = Dn(b);
            k?.focus();
          } else {
            var N;
            (N = E.beforeOutsideRef.current) == null || N.focus();
          }
      }
    }), !I && Ve("start"), n, Ve("end"), He && /* @__PURE__ */ ge(tt, {
      "data-type": "inside",
      ref: ft,
      onFocus: (L) => {
        if (l)
          Oe(K()[0]);
        else if (E != null && E.preserveTabOrder && E.portalNode)
          if (g && (v.current = !0), Fe(L, E.portalNode)) {
            const k = Fn(b);
            k?.focus();
          } else {
            var N;
            (N = E.afterOutsideRef.current) == null || N.focus();
          }
      }
    })]
  });
}
let Xe = 0;
const fn = "--floating-ui-scrollbar-width";
function Wo() {
  const e = It(), t = /iP(hone|ad|od)|iOS/.test(e) || // iPads can claim to be MacIntel
  e === "MacIntel" && navigator.maxTouchPoints > 1, n = document.body.style, o = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", i = window.innerWidth - document.documentElement.clientWidth, s = n.left ? parseFloat(n.left) : window.scrollX, c = n.top ? parseFloat(n.top) : window.scrollY;
  if (n.overflow = "hidden", n.setProperty(fn, i + "px"), i && (n[o] = i + "px"), t) {
    var u, l;
    const f = ((u = window.visualViewport) == null ? void 0 : u.offsetLeft) || 0, g = ((l = window.visualViewport) == null ? void 0 : l.offsetTop) || 0;
    Object.assign(n, {
      position: "fixed",
      top: -(c - Math.floor(g)) + "px",
      left: -(s - Math.floor(f)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(n, {
      overflow: "",
      [o]: ""
    }), n.removeProperty(fn), t && (Object.assign(n, {
      position: "",
      top: "",
      left: "",
      right: ""
    }), window.scrollTo(s, c));
  };
}
let dn = () => {
};
const ti = /* @__PURE__ */ m.forwardRef(function(t, n) {
  const {
    lockScroll: r = !1,
    ...o
  } = t;
  return J(() => {
    if (r)
      return Xe++, Xe === 1 && (dn = Wo()), () => {
        Xe--, Xe === 0 && dn();
      };
  }, [r]), /* @__PURE__ */ ge("div", {
    ref: n,
    ...o,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...o.style
    }
  });
});
function mn(e) {
  return U(e.target) && e.target.tagName === "BUTTON";
}
function _o(e) {
  return U(e.target) && e.target.tagName === "A";
}
function gn(e) {
  return Pt(e);
}
function ni(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: s = !0,
    event: c = "click",
    toggle: u = !0,
    ignoreMouse: l = !1,
    keyboardHandlers: f = !0,
    stickIfOpen: g = !0
  } = t, h = m.useRef(), a = m.useRef(!1), p = m.useMemo(() => ({
    onPointerDown(d) {
      h.current = d.pointerType;
    },
    onMouseDown(d) {
      const y = h.current;
      d.button === 0 && c !== "click" && (Ne(y, !0) && l || (n && u && (!(o.current.openEvent && g) || o.current.openEvent.type === "mousedown") ? r(!1, d.nativeEvent, "click") : (d.preventDefault(), r(!0, d.nativeEvent, "click"))));
    },
    onClick(d) {
      const y = h.current;
      if (c === "mousedown" && h.current) {
        h.current = void 0;
        return;
      }
      Ne(y, !0) && l || (n && u && (!(o.current.openEvent && g) || o.current.openEvent.type === "click") ? r(!1, d.nativeEvent, "click") : r(!0, d.nativeEvent, "click"));
    },
    onKeyDown(d) {
      h.current = void 0, !(d.defaultPrevented || !f || mn(d)) && (d.key === " " && !gn(i) && (d.preventDefault(), a.current = !0), !_o(d) && d.key === "Enter" && r(!(n && u), d.nativeEvent, "click"));
    },
    onKeyUp(d) {
      d.defaultPrevented || !f || mn(d) || gn(i) || d.key === " " && a.current && (a.current = !1, r(!(n && u), d.nativeEvent, "click"));
    }
  }), [o, i, c, l, f, r, n, g, u]);
  return m.useMemo(() => s ? {
    reference: p
  } : {}, [s, p]);
}
const $o = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, Vo = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, pn = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e?.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e?.outsidePress) != null ? n : !0
  };
};
function ri(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: i
  } = e, {
    enabled: s = !0,
    escapeKey: c = !0,
    outsidePress: u = !0,
    outsidePressEvent: l = "pointerdown",
    referencePress: f = !1,
    referencePressEvent: g = "pointerdown",
    ancestorScroll: h = !1,
    bubbles: a,
    capture: p
  } = t, d = lt(), y = Q(typeof u == "function" ? u : () => !1), R = typeof u == "function" ? y : u, b = m.useRef(!1), {
    escapeKey: w,
    outsidePress: S
  } = pn(a), {
    escapeKey: M,
    outsidePress: F
  } = pn(p), I = m.useRef(!1), W = Q((x) => {
    var E;
    if (!n || !s || !c || x.key !== "Escape" || I.current)
      return;
    const D = (E = i.current.floatingContext) == null ? void 0 : E.nodeId, C = d ? Le(d.nodesRef.current, D) : [];
    if (!w && (x.stopPropagation(), C.length > 0)) {
      let v = !0;
      if (C.forEach((T) => {
        var O;
        if ((O = T.context) != null && O.open && !T.context.dataRef.current.__escapeKeyBubbles) {
          v = !1;
          return;
        }
      }), !v)
        return;
    }
    r(!1, kr(x) ? x.nativeEvent : x, "escape-key");
  }), q = Q((x) => {
    var E;
    const D = () => {
      var C;
      W(x), (C = de(x)) == null || C.removeEventListener("keydown", D);
    };
    (E = de(x)) == null || E.addEventListener("keydown", D);
  }), _ = Q((x) => {
    var E;
    const D = i.current.insideReactTree;
    i.current.insideReactTree = !1;
    const C = b.current;
    if (b.current = !1, l === "click" && C || D || typeof R == "function" && !R(x))
      return;
    const v = de(x), T = "[" + Me("inert") + "]", O = Z(o.floating).querySelectorAll(T);
    let Y = H(v) ? v : null;
    for (; Y && !pe(Y); ) {
      const K = ve(Y);
      if (pe(K) || !H(K))
        break;
      Y = K;
    }
    if (O.length && H(v) && !Ir(v) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !G(v, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(O).every((K) => !G(Y, K)))
      return;
    if (U(v) && $) {
      const K = pe(v), oe = se(v), he = /auto|scroll/, at = K || he.test(oe.overflowX), ft = K || he.test(oe.overflowY), Ve = at && v.clientWidth > 0 && v.scrollWidth > v.clientWidth, He = ft && v.clientHeight > 0 && v.scrollHeight > v.clientHeight, L = oe.direction === "rtl", N = He && (L ? x.offsetX <= v.offsetWidth - v.clientWidth : x.offsetX > v.clientWidth), k = Ve && x.offsetY > v.clientHeight;
      if (N || k)
        return;
    }
    const P = (E = i.current.floatingContext) == null ? void 0 : E.nodeId, A = d && Le(d.nodesRef.current, P).some((K) => {
      var oe;
      return dt(x, (oe = K.context) == null ? void 0 : oe.elements.floating);
    });
    if (dt(x, o.floating) || dt(x, o.domReference) || A)
      return;
    const ce = d ? Le(d.nodesRef.current, P) : [];
    if (ce.length > 0) {
      let K = !0;
      if (ce.forEach((oe) => {
        var he;
        if ((he = oe.context) != null && he.open && !oe.context.dataRef.current.__outsidePressBubbles) {
          K = !1;
          return;
        }
      }), !K)
        return;
    }
    r(!1, x, "outside-press");
  }), B = Q((x) => {
    var E;
    const D = () => {
      var C;
      _(x), (C = de(x)) == null || C.removeEventListener(l, D);
    };
    (E = de(x)) == null || E.addEventListener(l, D);
  });
  m.useEffect(() => {
    if (!n || !s)
      return;
    i.current.__escapeKeyBubbles = w, i.current.__outsidePressBubbles = S;
    let x = -1;
    function E(O) {
      r(!1, O, "ancestor-scroll");
    }
    function D() {
      window.clearTimeout(x), I.current = !0;
    }
    function C() {
      x = window.setTimeout(
        () => {
          I.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        ot() ? 5 : 0
      );
    }
    const v = Z(o.floating);
    c && (v.addEventListener("keydown", M ? q : W, M), v.addEventListener("compositionstart", D), v.addEventListener("compositionend", C)), R && v.addEventListener(l, F ? B : _, F);
    let T = [];
    return h && (H(o.domReference) && (T = xe(o.domReference)), H(o.floating) && (T = T.concat(xe(o.floating))), !H(o.reference) && o.reference && o.reference.contextElement && (T = T.concat(xe(o.reference.contextElement)))), T = T.filter((O) => {
      var Y;
      return O !== ((Y = v.defaultView) == null ? void 0 : Y.visualViewport);
    }), T.forEach((O) => {
      O.addEventListener("scroll", E, {
        passive: !0
      });
    }), () => {
      c && (v.removeEventListener("keydown", M ? q : W, M), v.removeEventListener("compositionstart", D), v.removeEventListener("compositionend", C)), R && v.removeEventListener(l, F ? B : _, F), T.forEach((O) => {
        O.removeEventListener("scroll", E);
      }), window.clearTimeout(x);
    };
  }, [i, o, c, R, l, n, r, h, s, w, S, W, M, q, _, F, B]), m.useEffect(() => {
    i.current.insideReactTree = !1;
  }, [i, R, l]);
  const X = m.useMemo(() => ({
    onKeyDown: W,
    ...f && {
      [$o[g]]: (x) => {
        r(!1, x.nativeEvent, "reference-press");
      },
      ...g !== "click" && {
        onClick(x) {
          r(!1, x.nativeEvent, "reference-press");
        }
      }
    }
  }), [W, r, f, g]), $ = m.useMemo(() => ({
    onKeyDown: W,
    onMouseDown() {
      b.current = !0;
    },
    onMouseUp() {
      b.current = !0;
    },
    [Vo[l]]: () => {
      i.current.insideReactTree = !0;
    }
  }), [W, l, i]);
  return m.useMemo(() => s ? {
    reference: X,
    floating: $
  } : {}, [s, X, $]);
}
function Ho(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = Ft(), i = m.useRef({}), [s] = m.useState(() => So()), c = Nt() != null;
  if (process.env.NODE_ENV !== "production") {
    const a = r.reference;
    a && !H(a) && To("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [u, l] = m.useState(r.reference), f = Q((a, p, d) => {
    i.current.openEvent = a ? p : void 0, s.emit("openchange", {
      open: a,
      event: p,
      reason: d,
      nested: c
    }), n?.(a, p, d);
  }), g = m.useMemo(() => ({
    setPositionReference: l
  }), []), h = m.useMemo(() => ({
    reference: u || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [u, r.reference, r.floating]);
  return m.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: f,
    elements: h,
    events: s,
    floatingId: o,
    refs: g
  }), [t, f, h, s, o, g]);
}
function oi(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = Ho({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, s] = m.useState(null), [c, u] = m.useState(null), f = o?.domReference || i, g = m.useRef(null), h = lt();
  J(() => {
    f && (g.current = f);
  }, [f]);
  const a = yo({
    ...e,
    elements: {
      ...o,
      ...c && {
        reference: c
      }
    }
  }), p = m.useCallback((w) => {
    const S = H(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      getClientRects: () => w.getClientRects(),
      contextElement: w
    } : w;
    u(S), a.refs.setReference(S);
  }, [a.refs]), d = m.useCallback((w) => {
    (H(w) || w === null) && (g.current = w, s(w)), (H(a.refs.reference.current) || a.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !H(w)) && a.refs.setReference(w);
  }, [a.refs]), y = m.useMemo(() => ({
    ...a.refs,
    setReference: d,
    setPositionReference: p,
    domReference: g
  }), [a.refs, d, p]), R = m.useMemo(() => ({
    ...a.elements,
    domReference: f
  }), [a.elements, f]), b = m.useMemo(() => ({
    ...a,
    ...r,
    refs: y,
    elements: R,
    nodeId: t
  }), [a, y, R, t, r]);
  return J(() => {
    r.dataRef.current.floatingContext = b;
    const w = h?.nodesRef.current.find((S) => S.id === t);
    w && (w.context = b);
  }), m.useMemo(() => ({
    ...a,
    context: b,
    refs: y,
    elements: R
  }), [a, y, R, b]);
}
function yt() {
  return Or() && In();
}
function ii(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    dataRef: i,
    elements: s
  } = e, {
    enabled: c = !0,
    visibleOnly: u = !0
  } = t, l = m.useRef(!1), f = m.useRef(-1), g = m.useRef(!0);
  m.useEffect(() => {
    if (!c) return;
    const a = ee(s.domReference);
    function p() {
      !n && U(s.domReference) && s.domReference === we(Z(s.domReference)) && (l.current = !0);
    }
    function d() {
      g.current = !0;
    }
    function y() {
      g.current = !1;
    }
    return a.addEventListener("blur", p), yt() && (a.addEventListener("keydown", d, !0), a.addEventListener("pointerdown", y, !0)), () => {
      a.removeEventListener("blur", p), yt() && (a.removeEventListener("keydown", d, !0), a.removeEventListener("pointerdown", y, !0));
    };
  }, [s.domReference, n, c]), m.useEffect(() => {
    if (!c) return;
    function a(p) {
      let {
        reason: d
      } = p;
      (d === "reference-press" || d === "escape-key") && (l.current = !0);
    }
    return o.on("openchange", a), () => {
      o.off("openchange", a);
    };
  }, [o, c]), m.useEffect(() => () => {
    ne(f);
  }, []);
  const h = m.useMemo(() => ({
    onMouseLeave() {
      l.current = !1;
    },
    onFocus(a) {
      if (l.current) return;
      const p = de(a.nativeEvent);
      if (u && H(p)) {
        if (yt() && !a.relatedTarget) {
          if (!g.current && !Pt(p))
            return;
        } else if (!Pr(p))
          return;
      }
      r(!0, a.nativeEvent, "focus");
    },
    onBlur(a) {
      l.current = !1;
      const p = a.relatedTarget, d = a.nativeEvent, y = H(p) && p.hasAttribute(Me("focus-guard")) && p.getAttribute("data-type") === "outside";
      f.current = window.setTimeout(() => {
        var R;
        const b = we(s.domReference ? s.domReference.ownerDocument : document);
        !p && b === s.domReference || G((R = i.current.floatingContext) == null ? void 0 : R.refs.floating.current, b) || G(s.domReference, b) || y || r(!1, d, "focus");
      });
    }
  }), [i, s.domReference, r, u]);
  return m.useMemo(() => c ? {
    reference: h
  } : {}, [c, h]);
}
function wt(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [Jt]: s,
      [Qt]: c,
      ...u
    } = e;
    i = u;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [wo]: ""
    },
    ...i,
    ...t.map((s) => {
      const c = s ? s[n] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((s, c) => (c && Object.entries(c).forEach((u) => {
      let [l, f] = u;
      if (!(o && [Jt, Qt].includes(l)))
        if (l.indexOf("on") === 0) {
          if (r.has(l) || r.set(l, []), typeof f == "function") {
            var g;
            (g = r.get(l)) == null || g.push(f), s[l] = function() {
              for (var h, a = arguments.length, p = new Array(a), d = 0; d < a; d++)
                p[d] = arguments[d];
              return (h = r.get(l)) == null ? void 0 : h.map((y) => y(...p)).find((y) => y !== void 0);
            };
          }
        } else
          s[l] = f;
    }), s), {})
  };
}
function si(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c?.reference), n = e.map((c) => c?.floating), r = e.map((c) => c?.item), o = m.useCallback(
    (c) => wt(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = m.useCallback(
    (c) => wt(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), s = m.useCallback(
    (c) => wt(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return m.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: s
  }), [o, i, s]);
}
const Ko = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function ci(e, t) {
  var n, r;
  t === void 0 && (t = {});
  const {
    open: o,
    elements: i,
    floatingId: s
  } = e, {
    enabled: c = !0,
    role: u = "dialog"
  } = t, l = Ft(), f = ((n = i.domReference) == null ? void 0 : n.id) || l, g = m.useMemo(() => {
    var b;
    return ((b = At(i.floating)) == null ? void 0 : b.id) || s;
  }, [i.floating, s]), h = (r = Ko.get(u)) != null ? r : u, p = Nt() != null, d = m.useMemo(() => h === "tooltip" || u === "label" ? {
    ["aria-" + (u === "label" ? "labelledby" : "describedby")]: o ? g : void 0
  } : {
    "aria-expanded": o ? "true" : "false",
    "aria-haspopup": h === "alertdialog" ? "dialog" : h,
    "aria-controls": o ? g : void 0,
    ...h === "listbox" && {
      role: "combobox"
    },
    ...h === "menu" && {
      id: f
    },
    ...h === "menu" && p && {
      role: "menuitem"
    },
    ...u === "select" && {
      "aria-autocomplete": "none"
    },
    ...u === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [h, g, p, o, f, u]), y = m.useMemo(() => {
    const b = {
      id: g,
      ...h && {
        role: h
      }
    };
    return h === "tooltip" || u === "label" ? b : {
      ...b,
      ...h === "menu" && {
        "aria-labelledby": f
      }
    };
  }, [h, g, f, u]), R = m.useCallback((b) => {
    let {
      active: w,
      selected: S
    } = b;
    const M = {
      role: "option",
      ...w && {
        id: g + "-fui-option"
      }
    };
    switch (u) {
      case "select":
      case "combobox":
        return {
          ...M,
          "aria-selected": S
        };
    }
    return {};
  }, [g, u]);
  return m.useMemo(() => c ? {
    reference: d,
    floating: y,
    item: R
  } : {}, [c, d, y, R]);
}
export {
  Qo as F,
  oi as a,
  ni as b,
  Jo as c,
  ii as d,
  ri as e,
  ci as f,
  si as g,
  Xo as h,
  zo as i,
  Go as j,
  ti as k,
  ei as l,
  Uo as o,
  Yo as s,
  Zo as u
};
